import { useTableSearchQuery, useTableSearchTool, useTableSearchFilter } from './hooks'

import type { UseTableSearchParams, UseTableSearchReturn } from './types'

export const useTableSearch = <ColumnsType, DataSourceType extends {}>({
  columns,
  dataSource,
  columnsSearchSchema,
  tableSearchQuerySchema
}: UseTableSearchParams<ColumnsType, DataSourceType>): UseTableSearchReturn<ColumnsType, DataSourceType> => {
  const { tableSearchFromQuery: initialTableSearch, updateTableSearchQuery: onTableSearchChange } =
    useTableSearchQuery(tableSearchQuerySchema)

  const {
    columns: columnsWithSearchTool,
    tableSearch,
    isSearchToolOpened,
    toggleSearchTool
  } = useTableSearchTool({
    columns,
    initialTableSearch,
    columnsSearchSchema,
    onTableSearchChange
  })

  const { filteredDataSource } = useTableSearchFilter({
    dataSource,
    tableSearch,
    columnsSearchSchema
  })

  return {
    columns: columnsWithSearchTool,
    filteredDataSource,
    isSearchToolOpened,
    toggleSearchTool
  }
}
